<template>
  <Teleport to="body">
    <div v-if="uiStore.activePanel === 'stamp'" class="deco-panel-modal">
      <div class="deco-panel-backdrop" @click="uiStore.hidePanel()" />
      <div class="deco-panel-inner">
        <div class="deco-panel-header">
          <h3 class="deco-panel-title">スタンプを選択</h3>
          <button class="deco-panel-close" @click="uiStore.hidePanel()">✕</button>
        </div>
        <div class="deco-panel-scroll">
          <template v-for="group in allGroups" :key="group.id">
            <template v-if="group.has_stamp">
              <p class="deco-panel-group-label" :class="{ 'is-event': group.isEvent }">
                <template v-if="group.isEvent">⭐ 【限定】{{ group.name }}</template>
                <template v-else>{{ group.name }}</template>
              </p>
              <div class="deco-panel-grid">
                <button
                  v-for="deco in stampDecos(group)"
                  :key="deco.id"
                  class="deco-panel-item"
                  @click="addStamp(storageUrl + deco.image_url, deco.id)"
                >
                  <img :src="storageUrl + 'resize/' + deco.image_url" alt="" loading="lazy" decoding="async" />
                </button>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useDecoDataStore } from '../../stores/useDecoDataStore'
import { useUiStore } from '../../stores/useUiStore'
import { useAddDeco } from '../../composables/useAddDeco'

const decoDataStore = useDecoDataStore()
const uiStore = useUiStore()
const { addStamp } = useAddDeco()

const storageUrl = computed(() => decoDataStore.storageUrl)

const allGroups = computed(() => [
  ...(decoDataStore.stamps.styles ?? []).map(g => ({ ...g, isEvent: false })),
  ...(decoDataStore.stamps.events ?? []).map(g => ({ ...g, isEvent: true })),
  ...(decoDataStore.stamps.genres ?? []).map(g => ({ ...g, isEvent: false })),
])

function stampDecos(group) {
  return (group.decos ?? []).filter(d => d.is_public)
}
</script>
